import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "faq-list" }
const _hoisted_2 = { class: "faq-half-list" }
const _hoisted_3 = { class: "faq-half-list" }

import FAQSectionLayout from './FAQSectionLayout.vue'
import FAQUnit from './FAQUnit.vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'BillingFAQ',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(FAQSectionLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(FAQUnit, {
            type: "billing",
            title: "How is Shortform better than other sites?"
          }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createTextVNode(" We know there are a few summary providers out there. What we're famous for are our comprehensive, detailed book summaries. We cover far more ideas than our competitors, while still being concise. Compare one of our books to one of theirs, and you'll see how much useful information they leave out. Our summaries also feature interactive exercises and emphasize actionables, so you put the information you learn into practical use. Finally, we cover articles from leading publications like ", -1),
              _createElementVNode("em", null, "The New York Times", -1),
              _createTextVNode(" and ", -1),
              _createElementVNode("em", null, "The Economist", -1),
              _createTextVNode(", so you get access to more great ideas. ", -1)
            ]))]),
            _: 1
          }),
          _createVNode(FAQUnit, {
            type: "billing",
            title: "How much new content do you publish each month?"
          }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createTextVNode(" We currently publish 20+ new book summaries a month, as well as 40+ new article summaries. We're continuing to grow our writing team to cover more great ideas every day. ", -1)
            ]))]),
            _: 1
          }),
          _createVNode(FAQUnit, {
            type: "billing",
            title: "What genres do you cover?"
          }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createTextVNode(" Our summaries cover 30+ genres, including self-improvement, business, technology, spirituality, history, and politics. Our mission is to spread the world's best ideas, and that means writing broadly to cover all our subscribers' interests. ", -1)
            ]))]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(FAQUnit, {
            type: "billing",
            title: "Can I suggest materials to summarize?"
          }, {
            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
              _createTextVNode(" Yes! We take book suggestions from our subscribers all the time. Once you request a book, it'll be added to our shortlist of books to cover. The more often the book is requested, the sooner we'll publish our summary. ", -1)
            ]))]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }))
}
}

})